import React from 'react';
import {
  BlueIconImage,
  GiftIconContainer,
  GreenIconImage,
  YellowIconImage
} from './GiftsAnimationStyle';
import Fade from 'react-reveal/Fade';
import Image from '../../../utils/Image/Image';

const GiftsAnimation = () => {
  return (
    <GiftIconContainer>
      <Fade top delay={300} distance={'30px'}>
        <YellowIconImage>
            <Image
              imageName='yellowIcon'
              altText='yellowIcon'
              extension='png'
            />
        </YellowIconImage>
      </Fade>
      <Fade top delay={200} distance={'30px'}>
        <GreenIconImage>
            <Image
              imageName={'greenIcon'}
              extension="png"
              altText={'greenIcon'}
            />
        </GreenIconImage>
      </Fade>
      <Fade top delay={100} distance={'30px'}>
        <BlueIconImage>
          <Image
            imageName={'blueIcon'}
            extension="png"
            altText={'blueIcon'}
          />
        </BlueIconImage>
      </Fade>
    </GiftIconContainer>
  );
};

export default GiftsAnimation;